
import { IonApp, IonRouterOutlet } from "@ionic/vue";
import { defineComponent, onMounted } from "vue";

import { Drivers, Storage } from "@ionic/storage";

import Menu from "@/components/Menu.vue";
import InstallPrompt from "@/components/InstallPrompt.vue";
import { LOCALSTORAGE_KEY } from "@/custom_config.js";
import dipendenti from "@/services/dipendenti";
import { logOut } from "@/services/logout";
import { openToast } from "@/services/toast";

//import { useRouter } from "vue-router";

export default defineComponent({
    name: "App",
    components: {
        IonApp,
        IonRouterOutlet,
        Menu,
        InstallPrompt
    },
    setup() {
        onMounted(async () => {
            const userInfo = localStorage.getItem(LOCALSTORAGE_KEY);

            if (userInfo) {
                const user = JSON.parse(userInfo);

                if (user && user.dipendenti_id) {
                    try {
                        const response = await dipendenti.getDipendente(user.dipendenti_id);
                        console.log(response);

                        if (response.status === 200 && response.data.status === 0) {
                            const dipendente = response.data.data;

                            // Autologout se utente disattivato
                            if (dipendente.dipendenti_attivo == '0') {
                                openToast("La tua utenza è stata disattivata. Contatta l'amministratore.", "toast_danger");
                                setTimeout(() => {
                                    logOut();
                                }, 1000); // Ritardo per permettere al toast di essere mostrato
                                return; // Esce dalla funzione per evitare ulteriori controlli
                            }
                            // Autologout se cambiata email o password oppure tipologia
                            if (
                                (dipendente.dipendenti_email != user.dipendenti_email)
                                || (dipendente.dipendenti_tipologia != user.dipendenti_tipologia)
                                || (dipendente.dipendenti_password != user.dipendenti_password)
                            ) {
                                openToast("La tua utenza è stata modificata. Effettua nuovamente l'accesso.", "toast_danger");
                                setTimeout(() => {
                                    logOut();
                                }, 1000); // Ritardo per permettere al toast di essere mostrato
                                return; // Esce dalla funzione per evitare ulteriori controlli
                            }
                        }
                    } catch (e) {
                        logOut(); // esco comunque
                        openToast("Si è verificato un errore inatteso. Contatta l'amministratore.", "toast_danger");
                        console.error("Errore controllo utente", e);
                        return; // Esce dalla funzione per evitare ulteriori controlli
                    }
                }
            }
        });

        const storage = new Storage({
            name: "__mydb",
            driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
        });

        async function createStore() {
            await storage.create();
        }

        createStore();
    },
    /*setup() {
    const router = useRouter();
    console.log("inside App.vue");
    if (
      localStorage.getItem("userInfo") != null &&
      localStorage.getItem("ricordami") != null
    ) {
      console.log(localStorage.getItem("ricordami"));
      router.replace("/tabs/");
    }
  },*/
});
